"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnDataToInstance = void 0;
var LinkCell_1 = require("../components/LinkCell");
var DateRangeFilter_1 = require("../filters/DateRangeFilter");
var LikeFilter_1 = require("../filters/LikeFilter");
var SelectFilter_1 = require("../filters/SelectFilter");
var DEFAULT_LOCALE = 'ru';
function columnDataToInstance(data, lang, fetchCatalog, fetchSelectDataByUrl, cellFormatters, customFilters) {
    return data.map(function (c) {
        var title = c.title[lang] || c.title[DEFAULT_LOCALE];
        var groupTitle = c.groupTitle ? c.groupTitle[lang] || c.groupTitle[DEFAULT_LOCALE] : undefined;
        var bObjectTitle = c.bObjectTitle ? c.bObjectTitle[lang] || c.bObjectTitle[DEFAULT_LOCALE] : undefined;
        var Cell = cellFormatters && Boolean(cellFormatters[c.columnCode])
            ? cellFormatters[c.columnCode]
            : c.isLink
                ? LinkCell_1.LinkCell
                : undefined;
        var Filter = getFilter(c, customFilters);
        return __assign(__assign(__assign({ lang: lang, columnCode: c.columnCode, Header: title, shortHeader: getShortHeader(title), accessor: c.columnCode, disableFilters: c.disableFilter || !Filter, disableSortBy: c.disableSort, blockHide: c.blockHide, groupCode: c.groupCode, groupTitle: groupTitle, bObjectCode: c.bObjectCode, bObjectTitle: bObjectTitle,
            fetchCatalog: fetchCatalog,
            fetchSelectDataByUrl: fetchSelectDataByUrl, filterSource: c.filterSource, filterField: c.filterField, columnType: c.columnType, isVisible: false, defaultSort: c.defaultSort }, (Cell ? { Cell: Cell } : {})), (Filter ? { Filter: Filter } : {})), { rerenderKey: 0 });
    });
}
exports.columnDataToInstance = columnDataToInstance;
function getShortHeader(header) {
    var partsOfHeader = header.split(' \\ ');
    return partsOfHeader[partsOfHeader.length - 1] || header;
}
function getFilter(col, customFilters) {
    var columnType = col.columnType, columnCode = col.columnCode;
    if (customFilters && customFilters[columnCode]) {
        return customFilters[columnCode];
    }
    switch (columnType) {
        case 'select':
            return SelectFilter_1.SelectFilter;
        case 'datetime':
            return DateRangeFilter_1.DateRangeFilter;
        case 'textfield':
        case 'textarea':
        case 'address':
        case 'currency':
        case 'email':
        case 'url':
            return LikeFilter_1.LikeFilter;
        case 'expertiseRadio':
            return LikeFilter_1.LikeFilter;
        case 'expertiseScoreInput':
            return LikeFilter_1.LikeFilter;
        case 'expertiseScoreSelect':
            return LikeFilter_1.LikeFilter;
    }
}
